import axios from 'axios'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '../ruoyi'
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'
import useUserStore from '@/store/modules/user'
import { eui } from 'ems-ui'
import { triggerRelogin } from './relogin.js'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '/agent',
  // 超时
  timeout: 60 * 1000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = true//(config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  // 设置语言
  config.headers['Language'] = window.$str.getLanguage()
  config.headers['System-Sign'] = 'gemini3'

  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;               // 请求地址
      const s_data = sessionObj.data;             // 请求数据
      const s_time = sessionObj.time;             // 请求时间
      const interval = 200;                       // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = $str.getKey('全局/数据正在处理，请勿重复提交')
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  if (code === 401) {
    triggerRelogin();
    return Promise.reject(new Error($str.getKey('全局/无效的会话，或者会话已过期，请重新登录')))
  } else if (code === 'SUCCESS') {
    return Promise.resolve(res.data)
  } else if (code === 500) {
    eui.showToast(msg, 'error')
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    eui.showToast(msg, 'error')
    return Promise.reject(new Error('error'))
  } else {
    return Promise.resolve(res.data)
  }
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = $str.getKey('全局/后端接口连接异常');
    }
    else if (message.includes("timeout")) {
      message = $str.getKey('全局/系统接口请求超时');
    }
    else if (message.includes("Request failed with status code")) {
      message = $str.getKey('全局/系统接口异常', message.substr(message.length - 3));
    }
    eui.showToast(message, 'error', 5 * 1000)
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename) {
  eui.showLoading($str.getKey('全局/正在下载数据，请稍候'))
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob'
  }).then(async (data) => {
    const isLogin = await blobValidate(data);
    if (isLogin) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      eui.showToast(errMsg, 'error')
    }
  }).catch((r) => {
    console.error(r)
    eui.showToast($str.getKey('全局/下载文件出现错误，请联系管理员！'), 'error')
  }).finally(() => {
    eui.hideLoading()
  })
}



export default service
